module.exports = __webpack_public_path__ + "img/gridGalleryImage.9890fea4.svg";